<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12" class="text-center mt-12">
        <h1>Policy Confirmation</h1>
        <br />
        <p>
          Congragulations! Your QuickWill Estate policy was successfully issued!
        </p>
        <p>
          Policy number<br />
          <span class="policy-number">{{
            testator.insurance.rootPolicyNumber
          }}</span>
        </p>
        <p>
          Check your email for your email policy confirmation and documents.
        </p>

        <v-btn
          rounded
          depressed
          large
          color="primary"
          class="mt-8"
          @click="$router.push({ name: 'OverviewPage' })"
        >
          <span>Continue</span><v-icon small>{{ icons.mdiArrowRight }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PolicySuccessPage',
    props: {
      testator: {
        required: true,
        type: Object,
      },
    },
    created() {
      // Redirect to policy confirmation if doesn't have policy number
      if (
        !this.testator.insurance ||
        !this.testator.insurance.rootPolicyNumber
      ) {
        this.$router.push({ name: 'InsurancePolicyConfirmation' });
      }
    },
  };
</script>

<style lang="scss" scoped>
  .policy-number {
    font-size: 26px;
    font-weight: bold;
  }
</style>
